import Blue from "~/core";
import Masonry from "masonry-layout";
new Blue({
  name: "MasonryBlock",
  selector: ".masonry-grid",
  setup(masonry) {
    let grid = masonry;
    let gridEls = [...grid.querySelectorAll('.masonry-grid__item')];
    let images = [...grid.querySelectorAll('.masonry-grid__item img')];

    let dialogBox = document.querySelector('.masonry-dialog');
    let closeBtn = document.querySelector('.masonry-dialog__close');
    let nextBtn = document.querySelector('.masonry-dialog__next');
    let prevBtn = document.querySelector('.masonry-dialog__prev');
    grid.classList.add("is-visible");

    let totalImages = images.length;
    let imagesLoaded = 0;
    images.forEach(image => {
      let clonedImg = document.createElement("img");
      clonedImg.src = image.src;
      clonedImg.onload = () => {
        imageLoaded();
      }
    });

    if (grid.dataset.gallerymode.toUpperCase() === 'IMAGES') {
      gridEls.forEach(gridEl => {
        this.$addEvents(gridEl, 'click', function () {
          dialogBox.showModal();
          let index = gridEls.indexOf(gridEl);
          nextBtn.dataset.next = index + 1;
          prevBtn.dataset.previous = index - 1;
          switchTo(index);
        })
      });
    }
    this.$addEvents(closeBtn, 'click', function () {
      dialogBox.close();
    });
    this.$addEvents(nextBtn, 'click', function () {
      let index = nextBtn.dataset.index;
      if (index >= gridEls.length) {
        index = 0;
      }
      switchTo(index);
    });
    this.$addEvents(prevBtn, 'click', function () {
      let index = prevBtn.dataset.index;
      if (index < 0) {
        index = gridEls.length - 1;
      }
      switchTo(index);
    });
    const switchTo = (index) => {
      let gridElTitle = gridEls[index].dataset.title;
      let gridElLink = gridEls[index].dataset.link;
      let gridElImg = gridEls[index].dataset.src;
      let gridElDesc = gridEls[index].dataset.description;
      let gridElMeta = gridEls[index].dataset.meta;
      let gridElAuthor = gridEls[index].dataset.author;
      prevBtn.dataset.index = parseInt(index) - 1;
      nextBtn.dataset.index = parseInt(index) + 1;
      gridElTitle !== '' ? dialogBox.querySelector('.masonry-dialog__title').innerHTML = gridElTitle : dialogBox.querySelector('.masonry-dialog__title').innerHTML = '';
      if (gridElImg) dialogBox.querySelector('.masonry-dialog__img img').src = gridElImg;
      gridElDesc != '' ? dialogBox.querySelector('.masonry-dialog__description').innerHTML = gridElDesc : dialogBox.querySelector('.masonry-dialog__description').innerHTML = '';
      gridElMeta != '' ? dialogBox.querySelector('.masonry-dialog__meta').innerHTML = gridElMeta : dialogBox.querySelector('.masonry-dialog__meta').innerHTML = '';
    }
    const imageLoaded = () => {
      imagesLoaded++;
      if (imagesLoaded == totalImages) {
        allImagesLoaded();
      }
    }

    const allImagesLoaded = () => {
      setTimeout(() => {
        let msnry = new Masonry(grid, {
          itemSelector: 'none',
          columnWidth: 200,
          gutter: 5,
          stagger: 100
        });
        gridEls.forEach(element => {
          element.classList.add("loaded");
        });
        msnry.options.itemSelector = '.masonry-grid__item';
        msnry.appended(gridEls);
      }, 1000);
    }
  },
});

